module.exports = __webpack_public_path__ + "media/D_hourglass.dcfda770.mp3";